<template>
    <div style="padding: 6px 16px; background: #eee;">
        <span style="font-size: 14px; font-weight: bold">{{ title }}</span>
        <pm-price style="font-size: 14px; font-weight: 600; float: right;" :currency="$store.state.currency" :value="price" />
    </div>
</template>
<script>
export default {
    props: {
        title: {
            type: String,
            default: "",
        },
        price: {
            type: Number,
            default: 0,
        }
    }
}
</script>
